import {isNil} from 'lodash'
import {Ventrata} from 'types'

export const getSubtotalAmount = (order: Ventrata.Order) => {
  if (!order.pricing) {
    throw new Error(`'order.pricing' is not defined`)
  }

  if (isNil(order.pricing.retail)) {
    throw new Error(`'order.pricing.retail' is not defined`)
  }

  return order.pricing.retail
}
